var quantityLabel = "Cantidad";
var quantityFlyoutHeader = "Elija la cantidad";
var quantityFlyoutCTA = "Seleccionar esta cantidad";
var closeButton = "Cerrar";
var pricePlaceholder = "...";
var priceLabel = "Precio";
var unitPriceLabel = "Precio unitario";
var incompatibilityMessage = "No está disponible con otras opciones seleccionadas: ";
var select = "Seleccionar...";
var percentSavings = "{{{PERCENT}}}% de ahorro";
var sale = "ofertas";
var amountSavings = "ahorro de {{{AMOUNT}}}/unidad";
var amountSavingsWithSale = "ahorro de {{{AMOUNT}}}/unidad + oferta";
var seeMoreQuantities = "Ver más cantidades";
var required = "Obligatorio";
var sample = "Muestra";
var estimatedQuantity = "Cantidad estimada";
var numberOfRecipients = "{{{COUNT}}} destinatarios";
var recommendedCallout = "Recomendado";
var newCallout = "Nuevo";
var incompatibleLabel = "No es compatible";
var outOfStockCallout = "Agotado";
var dismissAlert = "Descartar alerta";
var unwindingMessage_1 = "No es compatible con {{{ATTRIBUTE1}}} {{{OPTION1}}}.";
var unwindingMessage_2 = "No es compatible con {{{ATTRIBUTE1}}} {{{OPTION1}}} y {{{ATTRIBUTE2}}} {{{OPTION2}}}.";
var unwindingMessage_3 = "No es compatible con {{{ATTRIBUTE1}}} {{{OPTION1}}},{{{ATTRIBUTE2}}} {{{OPTION2}}} y {{{ATTRIBUTE3}}} {{{OPTION3}}}.";
var unwindingMessage_more = "No es compatible con más de {{{ATTRIBUTE_COUNT}}} opciones.";
var unwindingAlertMessage_1 = "Para que sea compatible con {{{ATTRIBUTE}}} {{{OPTION}}}: se deseleccionó {{{ATTRIBUTE1}}} {{{OPTION1}}}.";
var unwindingAlertMessage_2 = "Para que sea compatible con {{{ATTRIBUTE}}} {{{OPTION}}}: se deseleccionó {{{ATTRIBUTE1}}} {{{OPTION1}}} y {{{ATTRIBUTE2}}} {{{OPTION2}}}.";
var unwindingAlertMessage_3 = "Para que sea compatible con {{{ATTRIBUTE}}}{{{OPTION}}}: se deseleccionó {{{ATTRIBUTE1}}} {{{OPTION1}}} , {{{ATTRIBUTE2}}}{{{OPTION2}}} y {{{ATTRIBUTE3}}} {{{OPTION3}}}.";
var unwindingAlertMessage_more = "Para que sea compatible con {{{ATTRIBUTE}}} {{{OPTION}}}: Se deseleccionaron más de {{{ATTRIBUTE_COUNT}}} opciones.";
var fullRangedHelperText = "{{{MINIMUM}}} {{{UNIT}}} a {{{MAXIMUM}}} {{{UNIT}}}";
var rangePartialRangedHelperText = "Por lo menos {{{MINIMUM}}} {{{UNIT}}}";
var fullRangedHelperTextForBooklets = "Ingrese una cantidad entre {{{MINIMUM}}} a {{{MAXIMUM}}} páginas, incluyendo la cubierta ";
var rangePartialRangedHelperTextForBooklets = "Por lo menos {{{MINIMUM}}} páginas, incluyendo la cubierta ";
var rangedGeneralInputError = "El dato ingresado no es válido";
var rangedBetweenRangesError = "Los números más cercanos son {{{LOWER}}} {{{UNIT}}} y {{{HIGHER}}} {{{UNIT}}}";
var rangedDecimalPrecisionError = "El número no puede sobrepasar 8 decimales";
var rangedMinInputValueError = "El número mínimo es {{{MINIMUM}}} {{{UNIT}}}";
var rangedMaxInputValueError = "El número máximo es {{{MAXIMUM}}} {{{UNIT}}}";
var rangedNotANumberError = "El dato ingresado debe ser un número";
var requiredAttributeFieldError = "Ingresar una cantidad entre {{{LOWER}}} y {{{HIGHER}}} {{{UNIT}}}";
var rangedBetweenRangesErrorForBooklets = "Los números más cercanos son de {{{LOWER}}} páginas y {{{HIGHER}}} páginas ";
var rangedMinInputValueErrorForBooklets = "El número mínimo es de {{{MINIMUM}}} páginas ";
var rangedMaxInputValueErrorForBooklets = "El número máximo es de {{{MAXIMUM}}} páginas ";
var requiredAttributeFieldErrorForBooklets = "Ingrese una cantidad entre {{{LOWER}}} a {{{HIGHER}}} páginas, incluyendo la cubierta ";
var requiredInformationToast = "Proporcione toda la información obligatoria.";
var esUs = {
	quantityLabel: quantityLabel,
	quantityFlyoutHeader: quantityFlyoutHeader,
	quantityFlyoutCTA: quantityFlyoutCTA,
	closeButton: closeButton,
	pricePlaceholder: pricePlaceholder,
	priceLabel: priceLabel,
	unitPriceLabel: unitPriceLabel,
	incompatibilityMessage: incompatibilityMessage,
	select: select,
	percentSavings: percentSavings,
	sale: sale,
	amountSavings: amountSavings,
	amountSavingsWithSale: amountSavingsWithSale,
	seeMoreQuantities: seeMoreQuantities,
	required: required,
	sample: sample,
	estimatedQuantity: estimatedQuantity,
	numberOfRecipients: numberOfRecipients,
	recommendedCallout: recommendedCallout,
	newCallout: newCallout,
	incompatibleLabel: incompatibleLabel,
	outOfStockCallout: outOfStockCallout,
	dismissAlert: dismissAlert,
	unwindingMessage_1: unwindingMessage_1,
	unwindingMessage_2: unwindingMessage_2,
	unwindingMessage_3: unwindingMessage_3,
	unwindingMessage_more: unwindingMessage_more,
	unwindingAlertMessage_1: unwindingAlertMessage_1,
	unwindingAlertMessage_2: unwindingAlertMessage_2,
	unwindingAlertMessage_3: unwindingAlertMessage_3,
	unwindingAlertMessage_more: unwindingAlertMessage_more,
	fullRangedHelperText: fullRangedHelperText,
	rangePartialRangedHelperText: rangePartialRangedHelperText,
	fullRangedHelperTextForBooklets: fullRangedHelperTextForBooklets,
	rangePartialRangedHelperTextForBooklets: rangePartialRangedHelperTextForBooklets,
	rangedGeneralInputError: rangedGeneralInputError,
	rangedBetweenRangesError: rangedBetweenRangesError,
	rangedDecimalPrecisionError: rangedDecimalPrecisionError,
	rangedMinInputValueError: rangedMinInputValueError,
	rangedMaxInputValueError: rangedMaxInputValueError,
	rangedNotANumberError: rangedNotANumberError,
	requiredAttributeFieldError: requiredAttributeFieldError,
	rangedBetweenRangesErrorForBooklets: rangedBetweenRangesErrorForBooklets,
	rangedMinInputValueErrorForBooklets: rangedMinInputValueErrorForBooklets,
	rangedMaxInputValueErrorForBooklets: rangedMaxInputValueErrorForBooklets,
	requiredAttributeFieldErrorForBooklets: requiredAttributeFieldErrorForBooklets,
	requiredInformationToast: requiredInformationToast
};

export { amountSavings, amountSavingsWithSale, closeButton, esUs as default, dismissAlert, estimatedQuantity, fullRangedHelperText, fullRangedHelperTextForBooklets, incompatibilityMessage, incompatibleLabel, newCallout, numberOfRecipients, outOfStockCallout, percentSavings, priceLabel, pricePlaceholder, quantityFlyoutCTA, quantityFlyoutHeader, quantityLabel, rangePartialRangedHelperText, rangePartialRangedHelperTextForBooklets, rangedBetweenRangesError, rangedBetweenRangesErrorForBooklets, rangedDecimalPrecisionError, rangedGeneralInputError, rangedMaxInputValueError, rangedMaxInputValueErrorForBooklets, rangedMinInputValueError, rangedMinInputValueErrorForBooklets, rangedNotANumberError, recommendedCallout, required, requiredAttributeFieldError, requiredAttributeFieldErrorForBooklets, requiredInformationToast, sale, sample, seeMoreQuantities, select, unitPriceLabel, unwindingAlertMessage_1, unwindingAlertMessage_2, unwindingAlertMessage_3, unwindingAlertMessage_more, unwindingMessage_1, unwindingMessage_2, unwindingMessage_3, unwindingMessage_more };
//# sourceMappingURL=es-us.json.mjs.map
